const Color = require('./Color');
const Fill = require('./Fill');

module.exports = {
    ...Color,
    ...Fill
};
